import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import logo from './logo.png'

const Footer = () => {
  const history = useHistory()
  const location = useLocation()

  const onPrivacyPolicyLinkClick = useCallback(() => {
    window.scroll({top: 0, behavior: "smooth"})
    if(location.pathname !== '/privacy-policy') history.push('/privacy-policy')
  }, [location, history])
  return (
    <div className='bg-black text-white p-10 grid grid-cols-1 md:grid-cols-2 text-sm'>
      <div className='order-last md:order-first'>
        <div>
          <img src={logo} alt='Poplink logo' width={50} height={50} />
        </div>
        <p>Made by Poplink. All right reserved</p>
      </div>
      <div className='flex flex-col md:flex-row md:ml-auto py-10'>
        <a
          href='mailto:yourfriends@poplink.in?subject=Reaching out via website&cc=anshul@poplink.in,akshay@poplink.in,raghav@poplink.in'
          target='_blank'
          rel='noopener noreferrer'
          className='text-gray-400 hover:text-white mr-2 mb-2'
        >
          Email us
        </a>
        <button className='text-gray-400 hover:text-white mr-2 mb-2' onClick={onPrivacyPolicyLinkClick}>Privacy Policy</button>
      </div>
    </div>
  )
}

export default Footer
